import React from 'react'

export const Accordion: React.FC = () => <h1>Accordion</h1>
